import {makeStyles} from '@material-ui/styles'
import {objOf, path, pipe, toLower} from 'ramda'
import React, {useCallback} from 'react'
import mergeRight from 'ramda/src/mergeRight'
import {SET_WORD} from '../../reducers/createGame'
import {useDispatch, useSelector} from 'react-redux'
import {selectWord} from '../../selectors/createGame'

const useStyles = makeStyles({
  root: {
    textAlign: 'center',
    padding: '8px 4px',
    border: 'none',
    borderBottom: '2px silver dashed',
    boxSizing: 'border-box',
    width: 'calc(100% - 8px)',
    color: 'rgba(0,0,128, 0.6)',
    fontFamily: '\'Coming Soon\', cursive',
    fontSize: '24px',
    fontKerning: 'none',
    transition: 'color 150ms ease-in-out',
    background: 'transparent',
    '&:focus': {
      outline: 'none',
      color: 'rgba(0,0,128, 1)',
      '&::placeholder': {
        transition: 'opacity 150ms ease-in-out',
        opacity: 0,
      },
    },
    '&::placeholder': {
      opacity: 1,
      color: 'rgba(0,0,128, 0.8)',
    },
  },
})

export default function Input(props) {
  const {root} = useStyles()
  const isSharing = useSelector(path(['createGame', 'isSharing']))
  const word = useSelector(selectWord)
  const setWord = pipe(createSetWordAction, useDispatch())

  const onChange = useCallback(
    pipe(path(['target', 'value']), setWord),
    [setWord],
  )

  return (
    <input
      className={root}
      placeholder="Think of a word..."
      disabled={isSharing}
      value={toLower(word)}
      onChange={onChange}
    />
  )
}

const createSetWordAction = pipe(
  objOf('word'),
  mergeRight(objOf('type', SET_WORD)),
)

